import React, { Component } from 'react';
import Link from 'gatsby-link'
import BourbonParty2 from '../assets/images/BB_Bourbon-70.jpg'
import BourbonParty3 from '../assets/images/BB_Bourbon-33.jpg'
import BourbonParty4 from '../assets/images/BB_Bourbon-78.jpg'
import BourbonParty5 from '../assets/images/BB_Bourbon-101.jpg'
import BourbonParty6 from '../assets/images/BB_Bourbon-61.jpg'

class TestimonialBlock extends Component {
    render() {
        return (
            <section>
                <div className="container">
                    <div className="columns">
                        <div className="column m-t-lg">
                            <div className="has-text-centered is-size-3">
                                Don't Take Our Word For It.
                            </div>
                            <div className="has-text-centered is-size-4">Here is what real guests say.</div>
                        </div>
                    </div>
                    <div className="columns">
                        <div className="column has-text-centered has-text-weight-bold">
                            <p className="is-size-1"><img src={BourbonParty5} /></p>
                            <div>"Really well organized, solid theme. Haven't been to a theme party like this before." - David B.</div>
                        </div>
                        <div className="column has-text-centered has-text-weight-bold">
                            <p className="is-size-1"><img src={BourbonParty6} /></p>
                            <div>"The decor was high quality and overall the theme felt cohesive which would save me time. This is
one of the most important things to me when planning a party." - Amanda M.</div>
                        </div>
                        <div className="column has-text-centered has-text-weight-bold">
                            <p className="is-size-1"><img src={BourbonParty3} /></p>
                            <div>"Instead of just a get together it had a theme with a few interesting experiences." - Michael G.</div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


export default TestimonialBlock


// WEBPACK FOOTER //
// ./src/components/testimonialBlock.js